<!-- GoodsSwipe.vue -->
<template>
  <div class="swipe-wrapper ui-common-swiper" v-if="detailInfo">
    <img v-if="detailInfo.pgoods_image" v-bind:src="detailInfo.pgoods_image" @click="setPopupVisible()" />
    <img v-else src="../../../../assets/image/home/default_image_banner.png" class="product-img" />
  </div>
</template>

<script>
import PreviewPicture from './PreviewPicture'
import { mapState, mapMutations } from 'vuex'
export default {
  data() {
    return {
      popupVisible: false
    }
  },

  components: {
    'v-picture': PreviewPicture
  },

  created() {
    this.$on('hide-priview-picture', value => {
      this.popupVisible = value
      this.setisPreviewPicture(value)
    })
  },

  computed: {
    ...mapState({
      detailInfo: state => state.pointsgoods.detailInfo
    }),
    getBannerStyle: function () {
      const { width } = window.screen
      let itemWidth = width
      let itemHeight = width
      return {
        width: itemWidth,
        height: itemHeight
      }
    }
  },

  methods: {
    ...mapMutations({
      setisPreviewPicture: 'setisPreviewPicture'
    }),

    setPopupVisible() {
      this.popupVisible = true
      this.setisPreviewPicture(true)
    }

  }
}
</script>
